import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Alert, Box, Button, Divider, Grid, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { LocalizationContext } from '@cvt/contexts';
import { emailRegex } from '@cvt/helpers/validation';
import { useRouter } from '@cvt/routing';

import { AuthContext } from '../contexts/AuthContext';
import { SignUpLayout } from '../components/Layout/SignUpLayout';
import { SignInBox } from '../components/Container/SignInBox';


export const ResetPassword = () => {
  const router = useRouter();
  const [success, setSuccess] = React.useState(false);
  const { dictionary } = React.useContext(LocalizationContext);
  const { resetPassword } = React.useContext(AuthContext);
  const { control, setError, handleSubmit, formState: { isSubmitting, errors } } = useForm({
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = React.useCallback(async (data: Auth.ResetPassword) => {
    try {
      resetPassword(data.email);
      setSuccess(true);
    } catch(e: any) {
      // @ts-ignore
      setError('email', { type: 'error', message: dictionary.auth.firebase.errors[e.error] || e.message });
      setSuccess(false);
    }
  }, [setError, dictionary, resetPassword]);

  return (
    <SignUpLayout>
      <Box height="100%" display="flex" flexDirection="column" justifyContent="center">
        <SignInBox>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container direction="column" spacing={2}>
              <Grid size={12}>
                <Typography variant="h4" align="center" color="textPrimary">{dictionary.auth.resetPassword.title}</Typography>
              </Grid>
              {success && (
                <Grid size={12}>
                  <Alert severity="success">{dictionary.auth.resetPassword.passwordResetEmailSent}</Alert>
                </Grid>
              )}
              <Grid size={12}>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: dictionary.forms.validations.required,
                    pattern: {
                      value: emailRegex,
                      message: dictionary.forms.validations.invalidEmail,
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      variant="outlined"
                      label={dictionary.forms.fieldEmail}
                      name="email"
                      error={!!errors.email}
                      helperText={errors.email?.message}
                    />
                  )}
                />
              </Grid>
              <Grid size={12}>
                <LoadingButton fullWidth loading={isSubmitting} size="large" type="submit" variant="contained" color="primaryAlt">
                  {dictionary.auth.resetPassword.buttonReset}
                </LoadingButton>
              </Grid>
              <Grid size={12}>
                <Divider orientation="horizontal" flexItem>
                  {dictionary.auth.divider}
                </Divider>
              </Grid>
              <Grid size={12} container>
                <Grid size={12}>
                  <Button fullWidth size="large" type="button" variant="contained" color="primaryAlt" onClick={() => router.auth.login.go()}>
                    {dictionary.auth.resetPassword.buttonLogin}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </SignInBox>
      </Box>
    </SignUpLayout>
  );
};
